var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useCallback, useMemo, useState } from "react";
import { Pane, Button, Checkbox, MenuSection, ConfirmationModal, ErrorModal, } from "@folio/stripes/components";
import { useOkapiKy } from "@folio/stripes/core";
import { useMutation, useQueryClient } from "react-query";
import { useIntl, FormattedMessage } from "react-intl";
import NavComponent from "../../components/NavComponent";
import TableComponent from "../../components/TableComponent";
import { useVariantTitlesColumn, VARIANT_TITLES_COLUMN_WIDTH, } from "../../hooks/useVariantTitlesColumn";
import { TitleDetail } from "./TitleDetail";
import { LibraryNoteDialog } from "../../components/title/LibraryNoteDialog";
import { BulkExcludePeriodicalsDialog } from "../../components/periodical/BulkExcludePeriodicalsDialog";
import { RecekPaneSet } from "../../components/RecekPaneSet";
import { RowClickBoundary } from "../../components/RowClickBoundary";
import { PublisherLink } from "../../components/publisher/PublisherLink";
import { createStripesSource } from "../../utils/createStripesSource";
import { formatIsbn } from "../../utils/isbn";
import { formatCountSubtitle } from "../../utils/paneCount";
import { frequencyLabelId } from "../../utils/frequencyLabel";
import { provisionalKey } from "../../utils/provisionalTitleKeys";
import { useTitleActions } from "../../hooks/useTitleActions";
import { useTitleVerificationFilters } from "../../hooks/useTitleVerificationFilters";
import { toTitleVerificationMatchFilter } from "../../utils/titleVerificationFilters";
import { TitleVerificationFilters } from "../../components/TitleVerificationFilters";
import { useTitlesVerificationData } from "../../hooks/useTitlesVerificationData";
import { useTitleSort } from "../../hooks/useTitleSort";
import { useListErrorMessage } from "../../hooks/useListErrorMessage";
import { columnSortKeys } from "../../utils/titleSort";
import { ROUTE_PATHS } from "../../types/routePaths";
import { useEditNavigation } from "../../utils/listReturn";
import { usePermissions } from "../../hooks/usePermissions";
import { startInvestigationByTitles, verifyTitlesBulk, deleteProvisionalTitle, forceDeleteProvisionalTitle, } from "../../api/titleService";
import { excludePeriodicalsByTitles } from "../../api/periodicalLibraryService";
import { upsertMyLibraryNoteByTitles } from "../../api/titleLibraryNoteService";
import { ProvisionalTitleModal, } from "../../components/title/ProvisionalTitleModal";
import { TitleMergeDialogs } from "../../components/title/merge/TitleMergeDialogs";
import { MergeResultCallout } from "../../components/title/merge/MergeResultCallout";
import { ProvisionalBadge } from "../../components/common/ProvisionalBadge";
import { NameCell } from "../../components/common/NameCell";
import { BulkStartInvestigationDialog } from "../../components/title/BulkStartInvestigationDialog";
import { BulkLibraryNoteDialog } from "../../components/title/BulkLibraryNoteDialog";
import { BulkVerifyTitlesDialog } from "../../components/title/BulkVerifyTitlesDialog";
import { useSelection } from "../../hooks/useSelection";
import { SelectAllBanner } from "../../components/selection/SelectAllBanner";
import { MAX_SELECTION_SIZE, } from "../../types/selection";
import { buildVerificationSelection } from "../../utils/buildTitleSelection";
import { hasHttpResponse } from "../../utils/apiUtils";
import css from "./TitleDetail.module.css";
export var TitlesForVerificationList = function (_a) {
    var _b, _c, _d, _e, _f;
    var type = _a.type;
    var navigateToEdit = useEditNavigation();
    var formatMessage = useIntl().formatMessage;
    var kyInstance = useOkapiKy();
    var queryClient = useQueryClient();
    var _g = useState(true), filterPaneIsVisible = _g[0], setFilterPaneIsVisible = _g[1];
    var _h = useState(false), startModalOpen = _h[0], setStartModalOpen = _h[1];
    var _j = useState(false), addNoteModalOpen = _j[0], setAddNoteModalOpen = _j[1];
    var _k = useState(false), resolveModalOpen = _k[0], setResolveModalOpen = _k[1];
    var _l = useState(false), libraryNoteDialogOpen = _l[0], setLibraryNoteDialogOpen = _l[1];
    var _m = useState(false), showBulkTakeOverDialog = _m[0], setShowBulkTakeOverDialog = _m[1];
    var _o = useState(false), showBulkVerifyDialog = _o[0], setShowBulkVerifyDialog = _o[1];
    var _p = useState(false), showBulkExcludeDialog = _p[0], setShowBulkExcludeDialog = _p[1];
    var _q = useState(false), showBulkNoteDialog = _q[0], setShowBulkNoteDialog = _q[1];
    var _r = useState(false), showSingleExcludeDialog = _r[0], setShowSingleExcludeDialog = _r[1];
    var _s = useState(null), bulkErrorMessage = _s[0], setBulkErrorMessage = _s[1];
    var _t = useState(false), provisionalModalOpen = _t[0], setProvisionalModalOpen = _t[1];
    var _u = useState(false), provisionalEditMode = _u[0], setProvisionalEditMode = _u[1];
    var _v = useState(false), deleteConfirmOpen = _v[0], setDeleteConfirmOpen = _v[1];
    var _w = useState(null), mergeRequest = _w[0], setMergeRequest = _w[1];
    var _x = useState(null), mergeCompletion = _x[0], setMergeCompletion = _x[1];
    var _y = useState(false), forceDeleteConfirmOpen = _y[0], setForceDeleteConfirmOpen = _y[1];
    var _z = useState(null), deleteErrorMessage = _z[0], setDeleteErrorMessage = _z[1];
    var _0 = usePermissions(), canVerifyTitleItem = _0.canVerifyTitleItem, canMergeTitles = _0.canMergeTitles, canForceDeleteProvisionalTitle = _0.canForceDeleteProvisionalTitle;
    var filtersHook = useTitleVerificationFilters(type);
    var actionsHook = useTitleActions(type);
    var variantTitlesColumn = useVariantTitlesColumn();
    var titleColumn = useMemo(function () { return ({
        name: formatMessage({ id: "ui-br-legaldeposits.titles.table.title" }),
        key: "title",
        sortKey: "name",
        alwaysVisible: true,
        clickable: true,
        onClick: function (item) {
            return actionsHook.handleRowClick(item.id);
        },
        cellRenderer: function (item) { return (React.createElement(NameCell, null,
            item.title,
            item.provisional && React.createElement(ProvisionalBadge, null))); },
    }); }, [formatMessage, actionsHook.handleRowClick]);
    var publisherColumns = useMemo(function () { return [
        {
            name: formatMessage({
                id: "ui-br-legaldeposits.titles.table.publisher",
            }),
            key: "publisherNameToCheck",
            sortKey: "publisher",
            cellRenderer: function (item) {
                var _a;
                return (React.createElement(PublisherLink, { name: (_a = item.publisherNameToCheck) !== null && _a !== void 0 ? _a : item.publisherName, publisherId: item.publisherId, tooltipId: "verification-publisher-".concat(item.id) }));
            },
        },
        {
            name: formatMessage({ id: "ui-br-legaldeposits.titles.table.place" }),
            key: "publisherPlaceToCheck",
            sortKey: "place",
        },
    ]; }, [formatMessage]);
    var investigationColumn = useMemo(function () { return ({
        name: formatMessage({ id: "ui-br-legaldeposits.titles.table.status" }),
        key: "investigationStatus",
        cellRenderer: function (item) {
            return item.investigationStatus === "IN_PROGRESS" ? (React.createElement("span", { className: css.investigationBadge },
                React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.investigation.status.inProgress" }))) : null;
        },
    }); }, [formatMessage]);
    var dataColumns = useMemo(function () {
        if (type === "PERIODICAL") {
            return __spreadArray(__spreadArray([
                titleColumn,
                {
                    name: formatMessage({
                        id: "ui-br-legaldeposits.titles.table.partNumber",
                    }),
                    key: "partNumber",
                    sortKey: "partNumber",
                },
                {
                    name: formatMessage({
                        id: "ui-br-legaldeposits.titles.table.partName",
                    }),
                    key: "partName",
                    sortKey: "partName",
                },
                variantTitlesColumn,
                {
                    name: formatMessage({
                        id: "ui-br-legaldeposits.periodicals.table.issn",
                    }),
                    key: "issn",
                    sortKey: "issn",
                },
                {
                    name: formatMessage({
                        id: "ui-br-legaldeposits.periodicals.table.frequency",
                    }),
                    key: "frequency",
                    sortKey: "frequency",
                    cellRenderer: function (item) { return (React.createElement(React.Fragment, null,
                        item.frequency
                            ? formatMessage({ id: frequencyLabelId(item.frequency) })
                            : null,
                        item.frequencyChangedAt && (React.createElement("span", { className: css.frequencyChangedBadge },
                            React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.periodicals.frequencyChanged.badge" }))))); },
                }
            ], publisherColumns, true), [
                investigationColumn,
            ], false);
        }
        return __spreadArray(__spreadArray([
            titleColumn,
            variantTitlesColumn,
            {
                name: formatMessage({ id: "ui-br-legaldeposits.titles.table.author" }),
                key: "author",
                sortKey: "author",
            },
            {
                name: formatMessage({ id: "ui-br-legaldeposits.titles.table.year" }),
                // The id stays "copyrightFrom" so saved column layouts keep this column's visibility and width.
                key: "copyrightFrom",
                sortKey: "year",
                cellRenderer: function (item) { return item.publicationYear; },
            }
        ], publisherColumns, true), [
            {
                name: formatMessage({ id: "ui-br-legaldeposits.titles.table.isbn" }),
                key: "isbn",
                sortKey: "isbn",
                cellRenderer: function (item) { return formatIsbn(item.isbn); },
            },
            {
                name: formatMessage({ id: "ui-br-legaldeposits.titles.table.edition" }),
                key: "editionStatement",
                sortKey: "edition",
                defaultHidden: true,
            },
            {
                name: formatMessage({ id: "ui-br-legaldeposits.titles.table.binding" }),
                key: "bindingText",
                sortKey: "binding",
                defaultHidden: true,
            },
            investigationColumn,
        ], false);
    }, [
        type,
        formatMessage,
        titleColumn,
        variantTitlesColumn,
        publisherColumns,
        investigationColumn,
    ]);
    var sortKeys = useMemo(function () { return columnSortKeys(dataColumns); }, [dataColumns]);
    var _1 = useTitleSort("verification.".concat(type), sortKeys), sort = _1.sort, handleSort = _1.handleSort;
    var dataHook = useTitlesVerificationData(filtersHook.appliedFilters, type, sort);
    var errorMessage = useListErrorMessage(dataHook.error);
    var handleSortAndRestartPaging = useCallback(function (sortKey) {
        dataHook.fetchMoreData(0);
        handleSort(sortKey);
    }, [dataHook, handleSort]);
    var pageIds = useMemo(function () { return dataHook.titlesData.map(function (t) { return t.id; }).filter(Boolean); }, [dataHook.titlesData]);
    var totalCount = (_b = dataHook.totalRecords) !== null && _b !== void 0 ? _b : pageIds.length;
    var matchFilter = useMemo(function () { return toTitleVerificationMatchFilter(filtersHook.appliedFilters, type); }, [filtersHook.appliedFilters, type]);
    var selection = useSelection({
        pageIds: pageIds,
        totalCount: totalCount,
        exactTotalCount: dataHook.exactTotalRecords,
        isCountCapped: dataHook.isCountCapped,
        filterDeps: [filtersHook.appliedFilters],
    });
    var basePath = useMemo(function () {
        return type === "PERIODICAL"
            ? ROUTE_PATHS.PERIODICALS_VERIFICATION
            : ROUTE_PATHS.TITLES_VERIFICATION;
    }, [type]);
    var selectedInvestigationStatus = useMemo(function () {
        var _a;
        return (_a = dataHook.titlesData.find(function (t) { var _a; return t.id === ((_a = actionsHook.selectedTitle) === null || _a === void 0 ? void 0 : _a.id); })) === null || _a === void 0 ? void 0 : _a.investigationStatus;
    }, [dataHook.titlesData, (_c = actionsHook.selectedTitle) === null || _c === void 0 ? void 0 : _c.id]);
    var isNone = !selectedInvestigationStatus || selectedInvestigationStatus === "NONE";
    var isInProgress = selectedInvestigationStatus === "IN_PROGRESS";
    var checkboxColumn = useMemo(function () { return ({
        name: (React.createElement(Checkbox, { checked: selection.isAllPageSelected, onChange: selection.togglePage })),
        key: "select",
        locked: true,
        cellRenderer: function (item) {
            var isChecked = selection.isRowSelected(item.id);
            var isLocked = selection.mode === "all";
            return (React.createElement(RowClickBoundary, { className: isChecked ? css.checkboxActive : css.checkboxMuted },
                React.createElement(Checkbox, { checked: isChecked, disabled: isLocked, onChange: function () { return selection.toggleRow(item.id); } })));
        },
    }); }, [selection]);
    var columns = useMemo(function () { return __spreadArray([checkboxColumn], dataColumns, true); }, [checkboxColumn, dataColumns]);
    var columnWidths = useMemo(function () {
        return type === "PERIODICAL"
            ? {
                select: "4%",
                title: "20%",
                partNumber: "6%",
                partName: "8%",
                variantTitles: VARIANT_TITLES_COLUMN_WIDTH,
                issn: "12%",
                frequency: "12%",
                publisherNameToCheck: "16%",
                publisherPlaceToCheck: "10%",
                investigationStatus: "12%",
            }
            : {
                select: "4%",
                title: "20%",
                variantTitles: VARIANT_TITLES_COLUMN_WIDTH,
                author: "15%",
                copyrightFrom: "7%",
                publisherNameToCheck: "17%",
                publisherPlaceToCheck: "10%",
                isbn: "13%",
                editionStatement: "9%",
                // Weights of the visible columns only; "Vazba/formát" cannot wrap, so it needs room for its text and sort icon.
                bindingText: "14%",
                investigationStatus: "14%",
            };
    }, [type]);
    var toggleFilterPane = function () { return setFilterPaneIsVisible(function (prev) { return !prev; }); };
    var source = createStripesSource({
        ky: null,
        data: dataHook.titlesData,
        totalRecords: dataHook.totalRecords,
        isLoading: dataHook.isLoading,
        isError: dataHook.isError,
        errorMessage: errorMessage,
        isLoaded: true,
        fetchMore: function () {
            return dataHook.fetchMoreData(dataHook.pageOffset + dataHook.pageSize);
        },
    });
    var afterBulkSuccess = useCallback(function () {
        selection.clearSelection();
        setBulkErrorMessage(null);
        queryClient.invalidateQueries(["titlesForVerification"]);
    }, [selection, queryClient]);
    var handleBulkError = useCallback(function (err) { return __awaiter(void 0, void 0, void 0, function () {
        var body, _a, message;
        var _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    if (!(hasHttpResponse(err) && err.response.status === 422)) return [3 /*break*/, 5];
                    body = null;
                    _d.label = 1;
                case 1:
                    _d.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, err.response.clone().json()];
                case 2:
                    body = _d.sent();
                    return [3 /*break*/, 4];
                case 3:
                    _a = _d.sent();
                    body = null;
                    return [3 /*break*/, 4];
                case 4:
                    message = (body === null || body === void 0 ? void 0 : body.message) ||
                        ((_c = (_b = body === null || body === void 0 ? void 0 : body.errors) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.message) ||
                        formatMessage({
                            id: "ui-br-legaldeposits.selection.limitExceeded.error",
                        });
                    setBulkErrorMessage(message);
                    return [2 /*return*/];
                case 5:
                    setBulkErrorMessage(formatMessage({ id: "ui-br-legaldeposits.bulk.error.generic" }));
                    return [2 /*return*/];
            }
        });
    }); }, [formatMessage]);
    var buildPayload = useCallback(function () {
        return buildVerificationSelection({
            mode: selection.mode,
            includeIds: selection.includeIds,
            excludeIds: selection.excludeIds,
        }, matchFilter);
    }, [selection.mode, selection.includeIds, selection.excludeIds, matchFilter]);
    var takeOverMutation = useMutation(function (_a) {
        var note = _a.note;
        return startInvestigationByTitles(kyInstance, buildPayload(), note);
    }, {
        onSuccess: function () {
            setShowBulkTakeOverDialog(false);
            afterBulkSuccess();
        },
        onError: handleBulkError,
    });
    var verifyMutation = useMutation(function (_a) {
        var publisherId = _a.publisherId;
        return verifyTitlesBulk(kyInstance, buildPayload(), publisherId);
    }, {
        onSuccess: function () {
            setShowBulkVerifyDialog(false);
            afterBulkSuccess();
        },
        onError: handleBulkError,
    });
    var excludeMutation = useMutation(function (_a) {
        var selection = _a.selection, reason = _a.reason, note = _a.note;
        return excludePeriodicalsByTitles(kyInstance, selection, reason, note);
    }, {
        onSuccess: function () {
            setShowBulkExcludeDialog(false);
            setShowSingleExcludeDialog(false);
            actionsHook.handleCloseDetail();
            afterBulkSuccess();
        },
        onError: handleBulkError,
    });
    var bulkNoteMutation = useMutation(function (_a) {
        var text = _a.text;
        return upsertMyLibraryNoteByTitles(kyInstance, buildPayload(), text);
    }, {
        onSuccess: function () {
            setShowBulkNoteDialog(false);
            queryClient.invalidateQueries(["title"]);
            queryClient.invalidateQueries(["title-detail"]);
            queryClient.invalidateQueries(["title-library-note-dialog"]);
            afterBulkSuccess();
        },
        onError: handleBulkError,
    });
    var selectedTitleId = (_d = actionsHook.selectedTitle) === null || _d === void 0 ? void 0 : _d.id;
    var isSelectedProvisional = Boolean((_e = actionsHook.selectedTitle) === null || _e === void 0 ? void 0 : _e.provisional);
    var isPeriodicalList = type === "PERIODICAL";
    var canOfferTitleMerge = canMergeTitles && (!isPeriodicalList || isSelectedProvisional);
    var provisionalEditInitialValues = useMemo(function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        if (!((_a = actionsHook.selectedTitle) === null || _a === void 0 ? void 0 : _a.provisional))
            return undefined;
        var isPeriodical = type === "PERIODICAL";
        return {
            name: (_b = actionsHook.selectedTitle.title) !== null && _b !== void 0 ? _b : "",
            author: (_c = actionsHook.selectedTitle.author) !== null && _c !== void 0 ? _c : "",
            isbn: isPeriodical
                ? undefined
                : ((_d = actionsHook.selectedTitle.isbn) !== null && _d !== void 0 ? _d : undefined),
            issn: isPeriodical
                ? ((_e = actionsHook.selectedTitle.issn) !== null && _e !== void 0 ? _e : undefined)
                : undefined,
            frequency: isPeriodical
                ? ((_f = actionsHook.selectedTitle.frequency) !== null && _f !== void 0 ? _f : undefined)
                : undefined,
            year: isPeriodical
                ? undefined
                : ((_g = actionsHook.selectedTitle.copyrightFrom) !== null && _g !== void 0 ? _g : undefined),
            publisherId: (_h = actionsHook.selectedTitle.ownerId) !== null && _h !== void 0 ? _h : undefined,
            publisherName: (_j = actionsHook.selectedTitle.publisherNameToCheck) !== null && _j !== void 0 ? _j : undefined,
            place: (_k = actionsHook.selectedTitle.publisherPlaceToCheck) !== null && _k !== void 0 ? _k : undefined,
            note: (_l = actionsHook.selectedTitle.provisionalNote) !== null && _l !== void 0 ? _l : "",
        };
    }, [actionsHook.selectedTitle, type]);
    var mapDeleteError = useCallback(function (err) { return __awaiter(void 0, void 0, void 0, function () {
        var status_1, code, body, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!hasHttpResponse(err)) return [3 /*break*/, 5];
                    status_1 = err.response.status;
                    code = void 0;
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, err.response.clone().json()];
                case 2:
                    body = _b.sent();
                    code = body === null || body === void 0 ? void 0 : body.code;
                    return [3 /*break*/, 4];
                case 3:
                    _a = _b.sent();
                    code = undefined;
                    return [3 /*break*/, 4];
                case 4:
                    if (status_1 === 403 || code === "NOT_FOUNDER") {
                        return [2 /*return*/, formatMessage({
                                id: provisionalKey(type, "delete.error.notFounder"),
                            })];
                    }
                    if (status_1 === 409 || code === "OTHER_LIBRARY_DEPOSITS") {
                        return [2 /*return*/, formatMessage({
                                id: provisionalKey(type, "delete.error.otherLibraryDeposits"),
                            })];
                    }
                    _b.label = 5;
                case 5: return [2 /*return*/, formatMessage({
                        id: provisionalKey(type, "delete.error.generic"),
                    })];
            }
        });
    }); }, [formatMessage, type]);
    var deleteMutation = useMutation(function (id) { return deleteProvisionalTitle(kyInstance, id); }, {
        onSuccess: function () {
            setDeleteConfirmOpen(false);
            actionsHook.handleCloseDetail();
            queryClient.invalidateQueries(["titlesForVerification"]);
        },
        onError: function (err) { return __awaiter(void 0, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        setDeleteConfirmOpen(false);
                        _a = setDeleteErrorMessage;
                        return [4 /*yield*/, mapDeleteError(err)];
                    case 1:
                        _a.apply(void 0, [_b.sent()]);
                        return [2 /*return*/];
                }
            });
        }); },
    });
    var handleConfirmDelete = useCallback(function () {
        if (selectedTitleId)
            deleteMutation.mutate(selectedTitleId);
    }, [selectedTitleId, deleteMutation]);
    var forceDeleteMutation = useMutation(function (id) { return forceDeleteProvisionalTitle(kyInstance, id); }, {
        onSuccess: function () {
            setForceDeleteConfirmOpen(false);
            actionsHook.handleCloseDetail();
            queryClient.invalidateQueries(["titlesForVerification"]);
        },
        onError: function (err) { return __awaiter(void 0, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        setForceDeleteConfirmOpen(false);
                        _a = setDeleteErrorMessage;
                        return [4 /*yield*/, mapDeleteError(err)];
                    case 1:
                        _a.apply(void 0, [_b.sent()]);
                        return [2 /*return*/];
                }
            });
        }); },
    });
    var handleConfirmForceDelete = useCallback(function () {
        if (selectedTitleId && !forceDeleteMutation.isLoading) {
            forceDeleteMutation.mutate(selectedTitleId);
        }
    }, [selectedTitleId, forceDeleteMutation]);
    var handleOpenMerge = useCallback(function (request) {
        setMergeCompletion(null);
        setMergeRequest(request);
    }, []);
    var handleMerged = useCallback(function (completion) {
        var _a;
        setMergeCompletion(completion);
        var openId = (_a = actionsHook.selectedTitle) === null || _a === void 0 ? void 0 : _a.id;
        if (openId && completion.plan.duplicateIds.includes(openId)) {
            actionsHook.handleCloseDetail();
        }
    }, [actionsHook]);
    return (React.createElement(RecekPaneSet, null,
        filterPaneIsVisible && (React.createElement(Pane, { id: "menuPane", defaultWidth: "25%", paneTitle: formatMessage({
                id: "ui-br-legaldeposits.pane.title.navigation",
            }) },
            React.createElement("div", { style: { display: "flex", flexDirection: "column" } },
                React.createElement(NavComponent, null),
                React.createElement(Button, { buttonStyle: "none", id: "clickable-reset-all", disabled: !filtersHook.isAnyFilterActive(), marginBottom0: true, onClick: filtersHook.handleClearFilters },
                    React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.button.resetAll" })),
                React.createElement(TitleVerificationFilters, { filters: filtersHook.filters, titleType: type === "PERIODICAL" ? "PERIODICAL" : "MONOGRAPH", onFilterChange: filtersHook.handleFilterChange, onProvisionalChange: filtersHook.handleProvisionalChange, onApplyFilters: filtersHook.handleApplyFilters, hasUnappliedChanges: filtersHook.hasUnappliedChanges() })))),
        React.createElement(Pane, { id: "contentPane", defaultWidth: "fill", paneTitle: formatMessage({
                id: type === "PERIODICAL"
                    ? "ui-br-legaldeposits.navigation.periodicals-verification"
                    : "ui-br-legaldeposits.navigation.titles-verification",
            }), paneSub: formatCountSubtitle(formatMessage, dataHook.totalRecords, dataHook.isCountCapped), actionMenu: function () { return (React.createElement(MenuSection, { id: "bulk-actions-menu", label: formatMessage({
                    id: "ui-br-legaldeposits.bulk.actions.label",
                }) },
                canVerifyTitleItem && (React.createElement(Button, { buttonStyle: "dropdownItem", fullWidth: true, onClick: function () {
                        setProvisionalEditMode(false);
                        setProvisionalModalOpen(true);
                    } },
                    React.createElement(FormattedMessage, { id: provisionalKey(type, "action") }))),
                canVerifyTitleItem && (React.createElement(Button, { buttonStyle: "dropdownItem", fullWidth: true, disabled: selection.selectedCount === 0, onClick: function () {
                        setBulkErrorMessage(null);
                        setShowBulkVerifyDialog(true);
                    } },
                    React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.bulk.actions.verifySelected", values: { count: selection.selectedCount } }))),
                React.createElement(Button, { buttonStyle: "dropdownItem", fullWidth: true, disabled: selection.selectedCount === 0, onClick: function () {
                        setBulkErrorMessage(null);
                        setShowBulkTakeOverDialog(true);
                    } },
                    React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.bulk.actions.takeOverSelected", values: { count: selection.selectedCount } })),
                React.createElement(Button, { buttonStyle: "dropdownItem", fullWidth: true, disabled: selection.selectedCount === 0, onClick: function () {
                        setBulkErrorMessage(null);
                        setShowBulkNoteDialog(true);
                    } },
                    React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.bulk.actions.libraryNoteSelected", values: { count: selection.selectedCount } })),
                type === "PERIODICAL" && (React.createElement(Button, { buttonStyle: "dropdownItem", fullWidth: true, disabled: selection.selectedCount === 0, onClick: function () {
                        setBulkErrorMessage(null);
                        setShowBulkExcludeDialog(true);
                    } },
                    React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.periodicals.bulk.actions.excludeSelected", values: { count: selection.selectedCount } }))))); } },
            React.createElement(SelectAllBanner, { mode: selection.mode, selectedCount: selection.selectedCount, pageRecordCount: pageIds.length, totalCount: totalCount, exactTotalCount: dataHook.exactTotalRecords, isCountCapped: dataHook.isCountCapped, limit: MAX_SELECTION_SIZE, onSelectAllAcrossFilter: selection.selectAllAcrossFilter, onClear: selection.clearSelection }),
            bulkErrorMessage && (React.createElement("div", { role: "alert", className: css.bulkError }, bulkErrorMessage)),
            mergeCompletion && (React.createElement(MergeResultCallout, { completion: mergeCompletion, onDismiss: function () { return setMergeCompletion(null); } })),
            React.createElement(TableComponent, { data: dataHook.titlesData, columns: columns, columnWidths: columnWidths, columnPrefsKey: "titles.verification.".concat(type), pageSize: dataHook.pageSize, onPageSizeChange: dataHook.changePageSize, totalCount: dataHook.totalRecords, onNeedMoreData: function (offset) { return dataHook.fetchMoreData(offset); }, searchTerm: "", filterPaneIsVisible: filterPaneIsVisible, toggleFilterPane: toggleFilterPane, source: source, isFetching: dataHook.isFetching, offset: dataHook.pageOffset, onRowClick: function (item) { return actionsHook.handleRowClick(item.id); }, sortBy: sort.sortBy, sortDir: sort.sortDir, onSort: handleSortAndRestartPaging, resetPaginationKey: "".concat(JSON.stringify(filtersHook.appliedFilters), "|").concat(sort.sortBy, "|").concat(sort.sortDir) })),
        actionsHook.selectedTitle && (React.createElement(Pane, { id: "detailPane", defaultWidth: "35%", paneTitle: formatMessage({
                id: "ui-br-legaldeposits.titles.detail.pane.title",
            }), onClose: actionsHook.handleCloseDetail, dismissible: true, actionMenu: function () { return (React.createElement(MenuSection, { label: formatMessage({
                    id: "ui-br-legaldeposits.action.menu.label",
                }), id: "actions-menu" },
                canVerifyTitleItem && (React.createElement(Button, { buttonStyle: "dropdownItem", onClick: function () {
                        var _a;
                        navigateToEdit("".concat(basePath, "/edit/").concat((_a = actionsHook.selectedTitle) === null || _a === void 0 ? void 0 : _a.id));
                    }, fullWidth: true },
                    React.createElement(FormattedMessage, { id: type === "PERIODICAL"
                            ? "ui-br-legaldeposits.title.detail.action.verifyPeriodical"
                            : "ui-br-legaldeposits.title.detail.action.verifyTitle" }))),
                isNone && (React.createElement(Button, { buttonStyle: "dropdownItem", onClick: function () { return setStartModalOpen(true); }, fullWidth: true },
                    React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.investigation.button.start" }))),
                isInProgress && (React.createElement(Button, { buttonStyle: "dropdownItem", onClick: function () { return setAddNoteModalOpen(true); }, fullWidth: true },
                    React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.investigation.button.addNote" }))),
                isInProgress && (React.createElement(Button, { buttonStyle: "dropdownItem", "data-testid": "investigation-resolve", onClick: function () { return setResolveModalOpen(true); }, fullWidth: true },
                    React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.investigation.button.resolve" }))),
                React.createElement(Button, { buttonStyle: "dropdownItem", onClick: function () { return setLibraryNoteDialogOpen(true); }, fullWidth: true },
                    React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.title.libraryNote.actionMenu" })),
                type === "PERIODICAL" && (React.createElement(Button, { buttonStyle: "dropdownItem", onClick: function () {
                        setBulkErrorMessage(null);
                        setShowSingleExcludeDialog(true);
                    }, fullWidth: true },
                    React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.periodicals.action.exclude" }))),
                isSelectedProvisional && (React.createElement(Button, { buttonStyle: "dropdownItem", onClick: function () {
                        setProvisionalEditMode(true);
                        setProvisionalModalOpen(true);
                    }, fullWidth: true },
                    React.createElement(FormattedMessage, { id: provisionalKey(type, "editAction") }))),
                canOfferTitleMerge && selectedTitleId && (React.createElement(Button, { buttonStyle: "dropdownItem", onClick: function () {
                        var _a, _b;
                        setDeleteErrorMessage(null);
                        handleOpenMerge({
                            titleIds: [selectedTitleId],
                            titleType: type,
                            provisionalId: isSelectedProvisional
                                ? selectedTitleId
                                : undefined,
                            provisionalName: (_b = (_a = actionsHook.selectedTitle) === null || _a === void 0 ? void 0 : _a.title) !== null && _b !== void 0 ? _b : undefined,
                        });
                    }, fullWidth: true, "data-test-id": "title-action-merge" },
                    React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.titleMerge.action" }))),
                isSelectedProvisional && (React.createElement(Button, { buttonStyle: "dropdownItem", onClick: function () {
                        setDeleteErrorMessage(null);
                        setDeleteConfirmOpen(true);
                    }, fullWidth: true },
                    React.createElement(FormattedMessage, { id: provisionalKey(type, "deleteAction") }))),
                isSelectedProvisional && canForceDeleteProvisionalTitle && (React.createElement(Button, { buttonStyle: "dropdownItem", onClick: function () {
                        setDeleteErrorMessage(null);
                        setForceDeleteConfirmOpen(true);
                    }, fullWidth: true },
                    React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.provisionalTitle.forceDelete.action" }))))); } },
            React.createElement(TitleDetail, { onOpenMerge: canMergeTitles && !isPeriodicalList ? handleOpenMerge : undefined, title: actionsHook.selectedTitle, investigationStatus: selectedInvestigationStatus, onInvestigationChanged: dataHook.refetch, startModalOpen: startModalOpen, onStartModalClose: function () { return setStartModalOpen(false); }, addNoteModalOpen: addNoteModalOpen, onAddNoteModalClose: function () { return setAddNoteModalOpen(false); }, resolveModalOpen: resolveModalOpen, onResolveModalClose: function () { return setResolveModalOpen(false); } }))),
        React.createElement(BulkStartInvestigationDialog, { open: showBulkTakeOverDialog, selectedCount: selection.selectedCount, onClose: function () { return setShowBulkTakeOverDialog(false); }, onSubmit: function (note) { return takeOverMutation.mutate({ note: note }); }, isLoading: takeOverMutation.isLoading }),
        React.createElement(BulkLibraryNoteDialog, { open: showBulkNoteDialog, selectedCount: selection.selectedCount, onClose: function () { return setShowBulkNoteDialog(false); }, onSubmit: function (text) { return bulkNoteMutation.mutate({ text: text }); }, isLoading: bulkNoteMutation.isLoading }),
        React.createElement(BulkVerifyTitlesDialog, { open: showBulkVerifyDialog, selectedCount: selection.selectedCount, onClose: function () { return setShowBulkVerifyDialog(false); }, onSubmit: function (publisherId) { return verifyMutation.mutate({ publisherId: publisherId }); }, isLoading: verifyMutation.isLoading }),
        React.createElement(BulkExcludePeriodicalsDialog, { open: showBulkExcludeDialog, selectedCount: selection.selectedCount, onClose: function () { return setShowBulkExcludeDialog(false); }, onSubmit: function (reason, note) {
                return excludeMutation.mutate({ selection: buildPayload(), reason: reason, note: note });
            }, isLoading: excludeMutation.isLoading }),
        React.createElement(BulkExcludePeriodicalsDialog, { open: showSingleExcludeDialog, selectedCount: 1, onClose: function () { return setShowSingleExcludeDialog(false); }, onSubmit: function (reason, note) {
                return excludeMutation.mutate({
                    selection: { includeIds: selectedTitleId ? [selectedTitleId] : [] },
                    reason: reason,
                    note: note,
                });
            }, isLoading: excludeMutation.isLoading }),
        actionsHook.selectedTitle && (React.createElement(LibraryNoteDialog, { open: libraryNoteDialogOpen, titleId: actionsHook.selectedTitle.id, titleName: (_f = actionsHook.selectedTitle.title) !== null && _f !== void 0 ? _f : "", onClose: function () { return setLibraryNoteDialogOpen(false); } })),
        React.createElement(ProvisionalTitleModal, { open: provisionalModalOpen, onClose: function () { return setProvisionalModalOpen(false); }, titleType: type, titleId: provisionalEditMode ? (selectedTitleId !== null && selectedTitleId !== void 0 ? selectedTitleId : undefined) : undefined, initialValues: provisionalEditMode ? provisionalEditInitialValues : undefined }),
        React.createElement(TitleMergeDialogs, { request: mergeRequest, onClose: function () { return setMergeRequest(null); }, onMerged: handleMerged, onProvisionalMerged: actionsHook.handleCloseDetail, preferredSurvivorId: isSelectedProvisional ? undefined : (selectedTitleId !== null && selectedTitleId !== void 0 ? selectedTitleId : undefined) }),
        React.createElement(ConfirmationModal, { open: forceDeleteConfirmOpen, heading: formatMessage({
                id: "ui-br-legaldeposits.provisionalTitle.forceDelete.confirm.heading",
            }), message: React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.provisionalTitle.forceDelete.confirm.message" }), confirmLabel: formatMessage({
                id: "ui-br-legaldeposits.provisionalTitle.forceDelete.confirm.button",
            }), onConfirm: handleConfirmForceDelete, onCancel: function () { return setForceDeleteConfirmOpen(false); } }),
        React.createElement(ConfirmationModal, { open: deleteConfirmOpen, heading: formatMessage({
                id: provisionalKey(type, "delete.confirm.heading"),
            }), message: React.createElement(FormattedMessage, { id: provisionalKey(type, "delete.confirm.message") }), confirmLabel: formatMessage({
                id: "ui-br-legaldeposits.provisionalTitle.delete.confirm.button",
            }), onConfirm: handleConfirmDelete, onCancel: function () { return setDeleteConfirmOpen(false); } }),
        React.createElement(ErrorModal, { open: Boolean(deleteErrorMessage), label: formatMessage({ id: "ui-br-legaldeposits.error.modal.title" }), content: deleteErrorMessage !== null && deleteErrorMessage !== void 0 ? deleteErrorMessage : "", onClose: function () { return setDeleteErrorMessage(null); } })));
};
